// src/api/admin.js
// Wrappers for every /admin endpoint. Each returns the unwrapped data payload
// or throws { message, code, status } built from the backend envelope.

import client from "./client";

const unwrap = (res) => res.data.data;

const apiError = (err) => {
  const body = err.response?.data;
  const e = new Error(body?.error || "Something went wrong. Try again.");
  e.code = body?.code || "NETWORK";
  e.status = err.response?.status || 0;
  return e;
};

const run = async (promise) => {
  try {
    return unwrap(await promise);
  } catch (err) {
    throw apiError(err);
  }
};

// ---- stats --------------------------------------------------------------
export const getStats = (params = {}) =>
  run(client.get("/admin/stats", { params }));

// ---- users --------------------------------------------------------------
export const listUsers = (params = {}) =>
  run(client.get("/admin/users", { params }));

export const createUser = (payload) => run(client.post("/admin/users", payload));

// ---- payments (EFT upgrade requests) ------------------------------------
export const listUpgradeIntents = () => run(client.get("/admin/upgrade-intents"));

export const getUser = (id) => run(client.get(`/admin/users/${id}`));

export const setUserRole = (id, role) =>
  run(client.patch(`/admin/users/${id}/role`, { role }));

export const setUserActive = (id, is_active) =>
  run(client.patch(`/admin/users/${id}/active`, { is_active }));

export const setUserTier = (id, tier, months) =>
  run(client.patch(`/admin/users/${id}/tier`, months ? { tier, months } : { tier }));

// ---- scan credits -------------------------------------------------------
export const getScanCredits = (owner) =>
  run(client.get("/admin/scan-credits", { params: owner }));

export const allocateScanCredits = (payload) =>
  run(client.post("/admin/scan-credits", payload));

// ---- scan pack purchases ------------------------------------------------
export const listPackPurchases = (params = {}) =>
  run(client.get("/admin/pack-purchases", { params }));

export const fulfilPack = (id) =>
  run(client.post(`/admin/pack-purchases/${id}/fulfil`));

export const cancelPack = (id) =>
  run(client.post(`/admin/pack-purchases/${id}/cancel`));

// ---- companies ----------------------------------------------------------
export const listCompanies = (params = {}) =>
  run(client.get("/admin/companies", { params }));

export const getCompany = (id) => run(client.get(`/admin/companies/${id}`));

export const createCompany = (payload) =>
  run(client.post("/admin/companies", payload));

export const updateCompany = (id, payload) =>
  run(client.patch(`/admin/companies/${id}`, payload));

export const listCompanyAdmins = (id) =>
  run(client.get(`/admin/companies/${id}/admins`));

export const createCompanyAdmin = (id, payload) =>
  run(client.post(`/admin/companies/${id}/admins`, payload));

export const removeCompanyAdmin = (id, userId) =>
  run(client.delete(`/admin/companies/${id}/admins/${userId}`));

// ---- vouchers -----------------------------------------------------------
export const listVouchers = () => run(client.get("/admin/vouchers"));

export const createVoucher = (payload) =>
  run(client.post("/admin/vouchers", payload));

export const setVoucherActive = (id, is_active) =>
  run(client.patch(`/admin/vouchers/${id}`, { is_active }));